import React from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import { INFOCLUB_DEFAULT_IMAGE } from "../utils/infoClubSettingsUtils";

export default function InfoClubPreviewPanel({
  previewSettings,
  previewDark,
  setPreviewDark,
}) {
  return (
    <aside className="space-y-5">
      <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

        <div className="p-4 sm:p-5">
          <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                Prévisualisation
              </p>

              <h3 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                Rendu de l’encart
              </h3>

              <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
                Aperçu proche de l’affichage réel sur la page d’accueil.
              </p>
            </div>

            <button
              type="button"
              onClick={() => setPreviewDark((value) => !value)}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              {previewDark ? <FaSun /> : <FaMoon />}
              {previewDark ? "Clair" : "Sombre"}
            </button>
          </div>

          <div className={previewDark ? "dark" : ""}>
            <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-950">
              {!previewSettings.isActive ? (
                <div className="rounded-2xl bg-slate-50 p-5 text-sm leading-6 text-slate-600 ring-1 ring-slate-200 dark:bg-slate-900 dark:text-slate-300 dark:ring-slate-800">
                  La section Info Club est <b>désactivée</b>. Elle n’apparaîtra
                  pas sur la page d’accueil.
                </div>
              ) : (
                <section className="mx-auto max-w-[1280px] bg-lightBackground px-4 py-6 text-black dark:bg-darkBackground dark:text-white">
                  <div className="flex flex-col overflow-hidden rounded-2xl border border-gray-300 bg-gradient-to-r from-slate-100 to-slate-200 shadow-xl dark:border-gray-800 dark:from-gray-700 dark:to-gray-800 lg:flex-row">
                    <div className="flex w-full flex-col justify-center p-6 font-montserrat lg:w-2/3 lg:p-8">
                      <h2 className="mb-4 text-2xl font-bold text-gray-800 dark:text-white sm:text-3xl">
                        {previewSettings.title}
                      </h2>

                      <div
                        className="infoclub-content text-justify leading-relaxed text-gray-700 dark:text-gray-300"
                        dangerouslySetInnerHTML={{
                          __html: previewSettings.content,
                        }}
                      />
                    </div>

                    <div className="max-h-[280px] w-full lg:w-1/3 lg:max-h-full">
                      <img
                        src={previewSettings.image}
                        alt={previewSettings.title || "Info Club"}
                        className="h-full w-full object-cover"
                        onError={(event) => {
                          event.currentTarget.src = INFOCLUB_DEFAULT_IMAGE;
                        }}
                      />
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>

        <style>{`
          .dark .infoclub-content strong,
          .dark .infoclub-content b {
            color: #fff;
          }

          .infoclub-content ul {
            list-style: disc;
            padding-left: 1.25rem;
          }

          .infoclub-content ol {
            list-style: decimal;
            padding-left: 1.25rem;
          }

          .infoclub-content a {
            color: #2563eb;
            text-decoration: underline;
            text-underline-offset: 3px;
          }

          .dark .infoclub-content a {
            color: #93c5fd;
          }
        `}</style>
      </section>
    </aside>
  );
}
